/*

      =========================================================
      * XGuard
      =========================================================
      
      * Product Page: https://www.nelx.net/xguard
      * Copyright 2024 NELX (https://www.nelx.net/)
      
      =========================================================
*/

import React from "react";
import { Flex } from "@chakra-ui/react";

export default function IconBox(props) {
  const { children, glowColor, ...rest } = props;

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"center"}
      borderRadius={"12px"}
      transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
      _hover={{
        transform: "scale(1.05)",
        boxShadow: glowColor 
          ? `0 0 20px ${glowColor}` 
          : "0 0 20px rgba(139, 92, 246, 0.5)",
      }}
      {...rest}>
      {children}
    </Flex>
  );
}
